import React, { useMemo, useState } from 'react'
import * as C from './style'
import { Button } from 'components/ui/button'
import { useYupValidationResolver } from 'hooks/useYupValidationResolver'
import { useForm, Controller } from "react-hook-form"
import * as yup from "yup"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faLock } from '@fortawesome/free-solid-svg-icons'
import { InputGroup } from 'components/ui/input'
import { Input } from 'components/ui/input'

const Password = (props: any) => {

    const schema = useMemo(
        () =>
            yup.object({
                password: yup.string().min(8).required(),
                repeatPassword: yup.string().required("password again is a required field").oneOf([yup.ref("password"), null], "passwords must match"),
            }),
        []
    )

    const resolver = useYupValidationResolver(schema)
    const { handleSubmit, control, formState: { errors } } = useForm({ resolver })

    const onSubmit = (data: any) => {
        props.onPasswordFinish(data.password)
    }

    return (
        <C.LoginMethod>

            <C.BackButton onClick={props.back}>
                <FontAwesomeIcon icon={faArrowLeft} />
            </C.BackButton>

            <C.Title >
                Set Your Password
            </C.Title>

            <C.Steps>
                <C.Step ></C.Step>
                <C.Step ></C.Step>
                <C.Step active="true"></C.Step>
            </C.Steps>

            <C.PasswordForm onSubmit={handleSubmit((data) => onSubmit(data))}>

                <InputGroup settings={{
                    icon: <FontAwesomeIcon icon={faLock} />,
                    label: "Password",
                    hint: errors.password?.message as string,
                    state: errors.password ? "error" : "default"
                }}>
                    <Controller name="password" control={control} render={({ field }) =>
                        <Input onBlur={field.onBlur} onChange={field.onChange} checked={field.value} xref={field.ref} type='password' placeholder='enter your password' autoFocus />}
                    />
                </InputGroup>

                <InputGroup settings={{
                    icon: <FontAwesomeIcon icon={faLock} />,
                    label: "Password Again",
                    hint: errors.repeatPassword?.message as string,
                    state: errors.repeatPassword ? "error" : "default"
                }}>
                    <Controller name="repeatPassword" control={control} render={({ field }) =>
                        <Input onBlur={field.onBlur} onChange={field.onChange} checked={field.value} xref={field.ref} type='password' placeholder='repeat your password' />}
                    />
                </InputGroup>

                <Button type="submit" variant="primary" size="large" block>Create Account</Button>

            </C.PasswordForm>
        </C.LoginMethod>
    )

}

export default Password